import { render, staticRenderFns } from "./assetDetail.vue?vue&type=template&id=64ab145b&scoped=true&"
import script from "./assetDetail.vue?vue&type=script&lang=js&"
export * from "./assetDetail.vue?vue&type=script&lang=js&"
import style0 from "./assetDetail.vue?vue&type=style&index=0&id=64ab145b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab145b",
  null
  
)

export default component.exports